// Short, explicit provider vocabulary for the board. New providers add an adapter here.
const LABELS = Object.freeze({
  bee: Object.freeze({
    PENDING: 'Solicitado',
    PICKUP_ONGOING: 'A caminho',
    ARRIVED_AT_MERCHANT: 'Chegou',
    ORDER_PICKED: 'Coletou',
    DELIVERY_ONGOING: 'Saiu',
    ARRIVED_AT_CUSTOMER: 'no cliente',
    RETURNING_TO_MERCHANT: 'Retornando',
    DELIVERY_FINISHED: 'Entregou',
    CANCELLED: 'Cancelou',
  }),
  ifood: Object.freeze({
    requested: 'Solicitado',
    searching: 'Buscando',
    assigned: 'A caminho',
    goingToOrigin: 'A caminho',
    arrivedAtOrigin: 'Chegou',
    inTransit: 'Saiu',
    concluded: 'Entregou',
    cancelled: 'Cancelou',
    cancellationAccepted: 'Cancelou',
  }),
});

const NAMES = Object.freeze({ bee: 'Bee', ifood: 'iFood' });

export const courierCardLabel = (provider, status) => {
  const short = LABELS[provider]?.[status];
  return short ? `${NAMES[provider]} ${short}` : '';
};

export const courierStatusBatches = (orders, size = 50) => {
  const batches = [];
  for (let index = 0; index < orders.length; index += size) batches.push(orders.slice(index, index + size));
  return batches;
};
